import React, { useRef, useState } from 'react';
import CommonLayout, { CommonLayoutInstance } from '@/components/CommonLayout';
import { deleteChannel, getChannel, postChannel, putChannel, getIpcAlarm, deleteIpcAlarm } from '@/api/channel';
import { Form, Input, Select, Switch } from 'antd';
import useFormHooks from '@/hooks/useForm';
import { WsFlvModal, WsFlvModalRef, WsFlvWithUrl } from '@/pages/video/components';
import dayjs from 'dayjs';

export const Channel = ({ device_id }: { device_id: string }) => {
  // console.log(device_id);
  const wsFlvModalRef = useRef<WsFlvModalRef>(null);
  const CommonLayoutRef = useRef<CommonLayoutInstance<{ params: {}; model: {}; drawerParams: {}; drawerModel: {} }>>(null);
  return (
    <CommonLayout
      ref={CommonLayoutRef}
      breadcrumb={{
        title: '',
        describe: '',
      }}
      isHideBreadcrumb
      ajaxJson={{
        get: { ajax: getChannel, params: { device_id } },
        delete: {
          // @ts-ignore
          ajax: deleteChannel,
        },
      }}
      tableProps={{}}
      columns={[
        { title: '设备ID', dataIndex: 'device_id' },
        { title: '通道ID', dataIndex: 'channel_id' },
        { title: '快照', dataIndex: 'test' },
        { title: '通道名称', dataIndex: 'name' },
        { title: '设备型号', dataIndex: 'model' },
        { title: '状态', dataIndex: 'status' },
        { title: '厂家', dataIndex: 'manufacturer' },
        { title: '位置', dataIndex: 'address' },
        {
          title: '创建时间',
          dataIndex: 'created',
          render(value) {
            return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
          },
        },
        {
          title: '更新时间',
          dataIndex: 'modified',
          render(value) {
            return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
          },
        },
      ]}
      operateButtonList={[
        {
          key: 'play',
          title: '播放',
          ajaxKey: 'play',
          name: '播放',
          filter: (data) => data.status !== 'ON',
          onClick: (data) => {
            wsFlvModalRef.current?.show({ channelId: data.channel_id, deviceId: data.device_id });
          },
        },
        {
          key: 'edit',
          title: '编辑',
          ajaxKey: 'edit',
          name: '编辑',
          isToShowDrawer: true,
          isToAjax: true,
        },
        {
          key: 'delete',
          title: '删除',
          ajaxKey: 'delete',
          name: '删除',
          isToPopConfirm: true,
          popconfirmProps: { title: '是否确认删除选中通道' },
          isToAjax: true,
          props: { danger: true },
          sortData: ({ id }: { id: string }) => ({ ids: [id] }),
        },
      ]}
      isHideOperateDetailButton
      searchFormChildren={
        <>
          <Form.Item name="channel_id">
            <Input placeholder="请输入通道ID"></Input>
          </Form.Item>

          <WsFlvModal ref={wsFlvModalRef}></WsFlvModal>
        </>
      }
      commonCbk={(key) => {
        if (key !== 'get') {
          CommonLayoutRef.current?.reload();
        }
      }}
      drawerJson={{
        formProps: { name: 'drawerForm-channel' },
        ajaxJson: {
          add: {
            // @ts-ignore
            ajax: postChannel,
          },
          edit: {
            // @ts-ignore
            ajax: putChannel,
          },
          delete: {
            // @ts-ignore
            ajax: deleteChannel,
          },
        },
        commonCbk: () => {
          CommonLayoutRef.current?.reload();
        },
        formChildren: (
          <>
            <Form.Item name="id" noStyle>
              <div></div>
            </Form.Item>
            <Form.Item name="device_id" label="设备ID">
              <Input placeholder="请输入设备ID" disabled></Input>
            </Form.Item>
            <Form.Item name="channel_id" label="通道ID">
              <Input placeholder="请输入通道ID"></Input>
            </Form.Item>
          </>
        ),
      }}
      searchFormRightOperateButtonList={[
        {
          name: '新增',
          title: '新增',
          ajaxKey: 'add',
          isToAjax: true,
          isToShowDrawer: true,
          props: { type: 'primary' },
          sortData: () => ({ device_id }),
        },
        { name: '删除', title: '删除', ajaxKey: 'delete1', props: { danger: true, type: 'primary', disabled: true }, filter: (data) => !!data?.length },
        {
          name: '删除',
          title: '删除',
          ajaxKey: 'delete',
          isToAjax: true,
          props: { danger: true, type: 'primary' },
          filter: (data) => !data?.length,
          isToPopConfirm: true,
          popconfirmProps: { title: '是否确认删除选中通道' },
          sortData: (data) => ({ ids: data.map((item: string | { id: string }) => (typeof item === 'string' ? item : item.id)) }),
        },
      ]}
      hasRowSelection
      isHideCardCls
      searchFormProps={{ name: 'searchForm-channel' }}
    ></CommonLayout>
  );
};

export const Alarm = ({ device_id }: { device_id: string }) => {
  // console.log(device_id);
  const CommonLayoutRef = useRef<CommonLayoutInstance<{ params: {}; model: {}; drawerParams: {}; drawerModel: {} }>>(null);
  return (
    <CommonLayout
      ref={CommonLayoutRef}
      breadcrumb={{
        title: '',
        describe: '',
      }}
      isHideBreadcrumb
      ajaxJson={{
        get: { ajax: getIpcAlarm, params: { device_id } },
        delete: {
          // @ts-ignore
          ajax: deleteIpcAlarm,
        },
      }}
      tableProps={{}}
      columns={[
        { title: '设备ID', dataIndex: 'device_id' },
        { title: '通道ID', dataIndex: 'channel_id' },
        { title: '告警级别', dataIndex: 'alarm_priority' },
        { title: '告警方式', dataIndex: 'alarm_method' },
        { title: '告警类型', dataIndex: 'alarm_type' },
        { title: '告警时间', dataIndex: 'alarm_time' },
      ]}
      operateButtonList={[
        {
          key: 'delete',
          title: '删除',
          ajaxKey: 'delete',
          name: '删除',
          isToPopConfirm: true,
          popconfirmProps: { title: '是否确认删除选中告警' },
          isToAjax: true,
          props: { danger: true },
          sortData: ({ id }: { id: string }) => ({ ids: [id] }),
        },
      ]}
      isHideOperateDetailButton
      searchFormChildren={
        <>
          <Form.Item name="alarm_priority">
            <Input placeholder="请输入告警级别"></Input>
          </Form.Item>
          <Form.Item name="alarm_method">
            <Input placeholder="请输入告警方式"></Input>
          </Form.Item>
          <Form.Item name="alarm_type">
            <Input placeholder="请输入告警类型"></Input>
          </Form.Item>
        </>
      }
      commonCbk={(key) => {
        if (key !== 'get') {
          CommonLayoutRef.current?.reload();
        }
      }}
      isHideDrawer
      searchFormRightOperateButtonList={[
        // {
        //   name: '新增',
        //   title: '新增',
        //   ajaxKey: 'add',
        //   isToAjax: true,
        //   isToShowDrawer: true,
        //   props: { type: 'primary' },
        //   sortData: () => ({ device_id }),
        // },
        { name: '删除', title: '删除', ajaxKey: 'delete1', props: { danger: true, type: 'primary', disabled: true }, filter: (data) => !!data?.length },
        {
          name: '删除',
          title: '删除',
          ajaxKey: 'delete',
          isToAjax: true,
          props: { danger: true, type: 'primary' },
          filter: (data) => !data?.length,
          isToPopConfirm: true,
          popconfirmProps: { title: '是否确认删除选中告警' },
          sortData: (data) => ({ ids: data.map((item: string | { id: string }) => (typeof item === 'string' ? item : item.id)) }),
        },
      ]}
      hasRowSelection
      isHideCardCls
      searchFormProps={{ name: 'searchForm-alarm' }}
    ></CommonLayout>
  );
};

export const StreamPlay = ({ device_id }: { device_id: string }) => {
  const [form] = Form.useForm();
  const [options, setOptions] = useState<{ channel_id: string; name: string }[]>([]);
  const { reload } = useFormHooks<object, object>({
    get: {
      ajax: getChannel,
      params: { isAll: true, device_id },
      cbk: (values) => {
        const list = values?.list?.filter((item: { status: string }) => item.status === 'ON') || [];
        setOptions(list);
        form.setFieldValue('channel_id', list?.[0]?.channel_id);
      },
    },
    // play: {
    //   // @ts-ignore
    //   ajax: postStreamsPlay,
    //   params: { device_id },
    //   cbk: () => {},
    // },
    // delete: {
    //   // @ts-ignore
    //   ajax: deleteStreams,
    // },
  });
  // @ts-ignore
  const [params, setParams] = useState<{ channelId?: string; deviceId?: string }>({});
  console.log(reload);
  const status = Form.useWatch('status', form);
  return (
    <div>
      <Form
        layout="inline"
        form={form}
        onValuesChange={(changedValues, { status, channel_id }) => {
          if (!status) setParams({});
          else {
            // @ts-ignore
            const { device_id } = options?.find((item) => item.channel_id === channel_id) || {};
            setParams({ deviceId: device_id, channelId: channel_id });
          }
          // const [key, value] = Object.entries(changedValues)[0];
          // if (key === 'status') {
          //   console.log({ key, value, values });
          //   if (value) {
          //     setParams({ deviceId: values.device_id, channelId: values.channel_id });
          //   } else {
          //     setParams({});
          //   }
          // } else {
          //   // if()
          // }
        }}
      >
        <Form.Item label="通道名称" name="channel_id">
          <Select style={{ minWidth: '240px' }} options={options} fieldNames={{ value: 'channel_id', label: 'name' }}></Select>
        </Form.Item>
        <Form.Item label="开启拉流" name="status">
          <Switch></Switch>
        </Form.Item>
      </Form>
      <div style={{ width: '100%', height: 500, background: '#ddd', borderRadius: 10, overflow: 'hidden', marginTop: 24 }}>
        {status && <WsFlvWithUrl id={'ipc-player'} isShowInfo {...(params as { channelId: string; deviceId: string })}></WsFlvWithUrl>}
      </div>
    </div>
  );
};
